import React from 'react'
import { PageLayout } from '../layouts/PageLayout'
import { AddReinstateEmployeePage } from './AddReinstateEmployeePage'
import { RouteComponentProps } from 'react-router-dom';
import {EmployeeProfile} from "react-angle-dashboard-components";

interface EmployeeRegistrationLocationState {
  employeeData: EmployeeProfile | undefined
}

export const EmployeeRegistration = (props: RouteComponentProps<{}, any, EmployeeRegistrationLocationState | any>) => {
  // TO DO - replace the use of the angle-components EmployerPortalEmployeeRegistration
  // with a new one
  return (
    <PageLayout
      breadcrumbs={[
        { title: 'Home', link: '/' },
        { title: 'Employees', link: '/employees' },
        { title: 'Add Employee', link: '/employees/registration' }
      ]}
    >
      <AddReinstateEmployeePage employeeData={props.history?.location?.state?.employeeData}/>
    </PageLayout>
  )
}

export default EmployeeRegistration
